import { render, staticRenderFns } from "./CoachMarks.vue?vue&type=template&id=36144c37"
import script from "./CoachMarks.vue?vue&type=script&lang=ts"
export * from "./CoachMarks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports